import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { getMap } from "../../../state/map";

const goToTime = 999999999999;
const animationTime = +(goToTime + "000");

type TimeAnimation = {
  currentTime: number;
  transitions: { currentTime: number };
};

type TimeAnimationObject = {
  timeAnimation: TimeAnimation;
  refrenceTimeAnimationProgress: number;
};

// Sets the time animation to a very high number. If you dont wait until map is loaded it bugs out
// We empty and fill the time animation to avoid a bug where the transition gets skipped
const useTimeAnimation = () => {
  const map = useSelector(getMap);

  const [timeAnimation, setTimeAnimation] = useState<TimeAnimationObject>({
    timeAnimation: {
      currentTime: 0,
      transitions: { currentTime: animationTime },
    },
    refrenceTimeAnimationProgress: 0,
  });

  // Empty the time animation
  useEffect(() => {
    if (map)
      setTimeAnimation({
        timeAnimation: {
          currentTime: 0,
          transitions: {
            currentTime: 0,
          },
        },
        refrenceTimeAnimationProgress: 0,
      });
  }, [map]);

  // Fill the time animation
  useEffect(() => {
    if (
      timeAnimation.timeAnimation.currentTime === 0 &&
      timeAnimation.timeAnimation.transitions.currentTime === 0 &&
      timeAnimation.refrenceTimeAnimationProgress === 0
    )
      setTimeout(() => {
        setTimeAnimation({
          timeAnimation: {
            currentTime: goToTime,
            transitions: {
              currentTime: animationTime,
            },
          },
          refrenceTimeAnimationProgress: new Date().getTime(),
        });
      });
  }, [timeAnimation]);

  return timeAnimation;
};

export default useTimeAnimation;
